<template>
  <div>После успешной загрузки приложения, на экране появится следующее окно:</div>
  <img src="@/assets/instruction/1.png">
  <div>
    <strong>В данном окне есть 3 кнопки:</strong>
    <ul>
      <li>
        <div class="button tag has-addons is-light my-link">
          <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-arrow-up-9-1" /></span>
          <span class="can-be-splitted">Мои обращения</span>
        </div>
        <i>используется для просмотра существующих обращений, а также возврата обращений или их закрытия.</i>
      </li>
      <li>
        <div class="button tag has-addons is-light my-link">
          <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-pen-to-square" /></span>
          <span class="can-be-splitted">Создать обращение</span>
        </div>
        <i>используется для регистрации новых обращений.</i>
      </li>
      <li>
        <div class="button tag has-addons is-light my-link">
          <span class="icon is-small"><font-awesome-icon icon="fa-solid fa-at" /></span>
          <span class="can-be-splitted">Получить отчёт</span>
        </div>
        <i>получить отчёт по состоянию обращений за текущий день.</i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home"
}
</script>

<style scoped lang="scss">
.my-link {
  width: 100%;
  border: 1px dashed rgba(0,0,0,0.1) !important;
}
.button {
  justify-content: left !important;
}
.can-be-splitted {
  word-wrap: break-word !important;
}

.is-active {
  text-decoration: underline 1px dashed rgb(45, 140, 0);
  border: 0px dashed red !important;
  //background-color: rgb(45, 140, 0) !important;
  //color: #ffffff !important;
  //font-weight: bold !important;
  .icon {
    color: rgb(45, 140, 0) !important;
    animation: shake 10s ease-in-out 0s infinite alternate-reverse backwards;
  }
}


@keyframes shake {
  0%,
  100% {
    transform: rotate(0deg);
    transform-origin: 50% 50%;
  }

  10% {
    transform: rotate(8deg);
  }

  20%,
  40%,
  60% {
    transform: rotate(-10deg);
  }

  30%,
  50%,
  70% {
    transform: rotate(10deg);
  }

  80% {
    transform: rotate(-8deg);
  }

  90% {
    transform: rotate(8deg);
  }
}
</style>